import { useContext } from "react";

// contexts
import { currencyContext } from "../../../context/currency-provider/CurrencyProvider";

// helpers
import { generateSkinImage } from "../../../helpers/generateSkinImage";

// types
import type { UpdatedSkinType } from "../../../context/skin-provider/SkinProvider.types";

// styles
import styles from "./PreviewCartProduct.module.scss";

type PreviewCartProductProps = {
  product: UpdatedSkinType;
};

export function PreviewCartProduct({ product }: PreviewCartProductProps) {
  const { getCurrencySymbol } = useContext(currencyContext);

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <div className={styles.imageWrapper}>
          <img src={generateSkinImage(product.class_id)} alt={product.name} />
        </div>

        <p className={styles.title}>{product.name}</p>
      </div>

      <p className={styles.price}>
        {getCurrencySymbol()} {product.price}
      </p>
    </div>
  );
}
